import { useEffect, useRef, useCallback, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useScrollDirection } from '../../hooks/scrollDirection';
import { updateAnnouncementData } from '../../slices/app-slice';
import { getAnnouncement } from '../../api';
import { useDataLoading } from '../../hooks/useDataLoading';

import Cart from '../cart';

import './styles.scss';

import logo from '../../assets/images/menu/logo.svg';
import logoWhite from '../../assets/images/menu/logo_white.svg';
import hamburger from '../../assets/images/menu/hamburger.svg';
import hamburgerWhite from '../../assets/images/menu/hamburger_white.svg';
import WishList from '../wishlist';
import Announcement from '../announcement';
import Search from '../search';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [hideBav, setHideNav] = useState(false);
    const [isAnnouncementLoading, setIsAnnouncementLoading] = useState(false);

    const ref = useRef()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const scrollDirection = useScrollDirection()
    const location = useLocation();

    const headerState = useSelector((state) => state.header.background);
    const isShowcase = useSelector((state) => state.header.isShowcase);
    const homepage = useSelector((state) => state.app.homepage);
    const announcement = homepage?.announcement;

    // Register loading state with splash wrapper
    useDataLoading('header-announcement', isAnnouncementLoading, [announcement]);

    // Fetch announcement data if not already populated
    useEffect(() => {
        const fetchAnnouncement = async () => {
            if (!announcement) {
                setIsAnnouncementLoading(true);
                try {
                    const response = await getAnnouncement();
                    // Update only the announcement field
                    dispatch(updateAnnouncementData(response.data));
                } catch (error) {
                    console.error('Error fetching announcement:', error);
                } finally {
                    setIsAnnouncementLoading(false);
                }
            }
        };

        fetchAnnouncement();
    }, [announcement, dispatch]);

    const closeDropdown = useCallback((e) => {
        if (ref.current && isOpen && !ref.current.contains(e.target)) {
            setIsOpen(false);
        }
    }, [isOpen]);


    useEffect(() => {
        switch (scrollDirection) {
            case 'down':
                setHideNav(true)
                break;
            case 'up':
                setHideNav(false);
                break;
            default:
                setHideNav(false);
                break;
        }
    }, [scrollDirection])

    useEffect(() => {
        if (window.PointerEvent) {
            document.addEventListener("pointerdown", closeDropdown);
        } else {
            document.addEventListener("pointerdown", closeDropdown);
        }
    }, [closeDropdown]);

    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname, dispatch, headerState]);

    // const handleRefresh = (e) => {
    //     e.preventDefault();
    //     navigate('/shop');
    //     window.location.reload();
    // };

    return (

        <div ref={ref} className={`header-wrapper`}>


            <div className={`header ${announcement ? "has-announcement" : ""} ${isOpen ? 'open' : 'closed'} ${headerState} ${hideBav && !isOpen && !isShowcase ? 'hide' : ''}`}>
                {announcement &&
                    <Announcement announcement={announcement} />
                }



                <div className='header-content'>
                    <div className='header-menu-btn' onClick={() => setIsOpen(!isOpen)}><img alt='' src={headerState === "light" || (isOpen && headerState === "transparent") ? hamburger : hamburgerWhite} />Menu</div>
                    <Link to="/">
                        {headerState === "light" || (isOpen && headerState === "transparent") ? <div className='header-logo'><img alt='' src={logo} /></div> : <div className='header-logo'><img alt='' src={logoWhite} /></div>}
                    </Link>
                    <div className='header-tools'>
                        <Search />
                        <WishList />
                        <Cart />
                    </div>
                </div>
            </div>

            <div className={`header-menu-wrapper ${isOpen ? 'open' : 'closed'}`}>
                <div className='header-menu'>
                    <Search />
                    <ul className='shaded'>
                        <li><label>Shop</label></li>
                        <li><span><Link to="/shop">Shop</Link></span></li>
                        <li><span><Link to="/divergence">Table Builder</Link></span></li>
                        <li><span><Link to="/slabs">Slabs</Link></span></li>
                        <li><span><Link to="/bases">Bases</Link></span></li>
                        <li><span><Link to="/custom-design">Paramount Exclusive</Link></span></li>
                    </ul>

                    <ul>
                        <li><label>Studio</label></li>
                        <li><span><Link to="/portfolio">Client Portfolio</Link></span></li>
                        <li><span><Link to="/jeffrey-greene">Jeffrey Greene</Link></span></li>
                        <li><span><Link to="/additional-services">Additional Services</Link></span></li>

                    </ul>

                    <ul>
                        <li><label>Info</label></li>
                        <li><span><Link to="/our-story">Our Story</Link></span></li>
                        <li><span><Link to="/contact">Contact</Link></span></li>
                    </ul>
                </div>

                <div className='header-promos'>
                    <div className='promo hover-zoom' onClick={() => navigate("/shop")}>
                        <div className='overlay light'>
                            <h2>Shop</h2>
                            <p>A curated selection of artisan pieces.</p>
                        </div>
                    </div>
                    <div className='promo hover-zoom' onClick={() => navigate("/divergence")}>
                        <div className='overlay light'>
                            <h2>Table Builder</h2>
                            <p>Build Your Own Dining Table.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;